import type { NodeV2 } from '@vedalib/editor'
import React, { useMemo } from 'react'

import { useProjectContext } from 'services/Store/Project/hooks'
import { getPlaceholders } from 'services/Store/Project/selectors'
import { Block } from 'services/Store/Project/types'

import * as s from './DragPlaceholderAbsolute.module.scss'

interface IPlaceholderProps {
  block: Block
  node: NodeV2
}

const DragPlaceholderAbsolute: React.FC<IPlaceholderProps> = ({ node }) => {
  const dnd = useProjectContext(getPlaceholders, node.id)
  // const device = useProjectContext(getDeviceMode)
  const coords = useMemo(() => {
    return Object.values(dnd?.coords || {}).map((coord) => {
      const [topMargin, rightMargin, bottomMargin, leftMargin] = coord.offset
      return {
        top: coord.top != null ? coord.top : undefined,
        left: coord.left != null ? coord.left : undefined,
        bottom: coord.bottom != null ? coord.bottom : undefined,
        right: coord.right != null ? coord.right : undefined,
        width: coord.width + (leftMargin || 0) + (rightMargin || 0),
        height: coord.height + (topMargin || 0) + (bottomMargin || 0),
      }
    })
  }, [dnd?.coords])

  // const { top, left, bottom, right } = useMemo(
  //   () => ({
  //     top: Math.min(...coords.map((i) => i.top ?? Infinity)),
  //     left: Math.min(...coords.map((i) => i.left ?? Infinity)),
  //     right: Math.min(...coords.map((i) => i.right ?? Infinity)),
  //     bottom: Math.min(...coords.map((i) => i.bottom ?? Infinity)),
  //   }),
  //   [coords],
  // )

  return (
    <>
      {/* {(dnd?.targetIds?.length || 0) > 1 && (
        <div className={s.group} style={{ top, left, right, bottom }} />
      )} */}
      {coords?.map((style, idx) => (
        <div className={s.element} key={dnd?.targetIds?.[idx]} style={style} />
      ))}
    </>
  )
}

export default DragPlaceholderAbsolute
